<template>
  <div style="height:580px;">
    <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;">
      <h5><b>My Claims</b></h5>
    </div>
  </div>
</template>
<script>
  export default {
  }
</script>